import { Schemas } from '../models/entities';

import * as ActionTypes from './types';

const fetchClients = (pageSize, pageNumber, sortBy, sortDesc, query) => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_CLIENTS_REQUEST,
      ActionTypes.FETCH_CLIENTS_SUCCESS,
      ActionTypes.FETCH_CLIENTS_FAILURE,
    ],
    schema: Schemas.CLIENT_ARRAY,
    endpoint: `/api/utilities?page=${pageNumber}&pageSize=${pageSize}&sortBy=${sortBy || ''}&sortDesc=${sortDesc}&search=${query ? encodeURI(query) : ''}`,
  },
});

export const loadClients = (query) => (dispatch, getState) => {
  const {
    pageSize = 10,
    pageNumber = 0,
  } = getState().pagination.clients || {};
  const {
    sortBy = null,
    sortDesc = false,
  } = getState().sorting.clients || {};
  return dispatch(fetchClients(pageSize, pageNumber, sortBy, sortDesc, query));
};

const postClient = (body) => ({
  [ActionTypes.API_CALL]: {
    method: 'POST',
    types: [
      ActionTypes.ADD_CLIENT_REQUEST,
      ActionTypes.ADD_CLIENT_SUCCESS,
      ActionTypes.ADD_CLIENT_FAILURE,
    ],
    endpoint: '/api/utilities',
    body,
  },
});

export const addClient = (client) => (dispatch) => dispatch(postClient(client));

const putClient = (client) => ({
  [ActionTypes.API_CALL]: {
    method: 'PUT',
    types: [
      ActionTypes.UPDATE_CLIENT_REQUEST,
      ActionTypes.UPDATE_CLIENT_SUCCESS,
      ActionTypes.UPDATE_CLIENT_FAILURE,
    ],
    endpoint: `/api/utilities/${client.id}`,
    body: client,
  },
});

export const updateClient = (client) => (dispatch) => dispatch(putClient(client));

const deleteClient = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'DELETE',
    types: [
      ActionTypes.DEACTIVATE_CLIENT_REQUEST,
      ActionTypes.DEACTIVATE_CLIENT_SUCCESS,
      ActionTypes.DEACTIVATE_CLIENT_FAILURE,
    ],
    endpoint: `/api/utilities/${id}`,
  },
});

export const deactivateClient = (id) => (dispatch) => dispatch(deleteClient(id));
